export default "__VITE_PUBLIC_ASSET__cb2c45fb__"